import { render, staticRenderFns } from "./WorkShiftSettings.vue?vue&type=template&id=fbfc92a0&"
import script from "./WorkShiftSettings.vue?vue&type=script&lang=js&"
export * from "./WorkShiftSettings.vue?vue&type=script&lang=js&"
import style0 from "./WorkShiftSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QSelect,QCheckbox,QInput,QItemSection,QExpansionItem} from 'quasar'
component.options.components = Object.assign({QItem,QSelect,QCheckbox,QInput,QItemSection,QExpansionItem}, component.options.components || {})
